<template>

    <create-document
        :post-url="route('api.v1.projects.createdocument', {project_uuid: this.project.uuid})"
    ></create-document>

</template>

<script>

import { mapGetters } from 'vuex';
import CreateDocument from "../../../components/Projects/CreateDocument";

export default {

    components: {
        CreateDocument,
    },

    computed: {
        ...mapGetters([
            'getProject',
        ]),

        project() {
            return this.getProject;
        },
    },

    metaInfo: {
        title:'Project document toevoegen',
    },

    name:'ProjectsDetailsAddDocument',

}

</script>
